import React from 'react';
import PropTypes from 'prop-types';

//styles
import { Input } from './Input.styled';

interface IFormInput {
  type: string;
  name: string;
  placeholder?: string;
  autocomplete?: string;
  error: boolean | string | undefined;
  disabled?: boolean;
  readOnly?: boolean;
  pasteDisabled?: boolean;
  style?: object;
  onChange?: () => void;
  onBlur?: () => void;
}

export const FormInput = ({
  type,
  name,
  error,
  disabled,
  readOnly,
  pasteDisabled,
  style,
  placeholder,
  autocomplete,
  onChange,
  onBlur,
}: IFormInput) => {
  // TODO should be updated we should send formiks setFieldValue as default onChange behavior
  return (
    <>
      {onChange ? (
        <Input
          disabled={disabled}
          readOnly={readOnly}
          onChange={onChange}
          type={type}
          name={name}
          style={style}
          autocomplete={autocomplete}
          placeholder={placeholder}
          error={error ? 'hasError' : 'noError'}
          onPaste={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (pasteDisabled) {
              return e.preventDefault();
            }
          }}
        />
      ) : (
        <Input
          onFocus={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          type={type}
          name={name}
          style={style}
          placeholder={placeholder}
          autocomplete={autocomplete}
          error={error ? 'hasError' : 'noError'}
          onPaste={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (pasteDisabled) {
              return e.preventDefault();
            }
          }}
        />
      )}
    </>
  );
};
